import { useRef } from 'react'

import dynamic from 'next/dynamic'
import { type Editor } from 'tinymce'

import {
  RichText,
  RichTextCaptureBlock,
} from '../../modules/templates/types/blueprint'
import { AutoAudioTranscriber } from '../ai/AudioTranscriber'
import { InputBeautify } from '../ai/InputBeautify'

import { useAuth } from '@/context/authContext'

const TinyMCE = dynamic(() => import('../util-components/TinyMCE'), {
  ssr: false,
})

type Props = {
  value?: RichText
  onChange?: (value: RichText) => void
  block: RichTextCaptureBlock
}

export const RichTextInput: React.FC<Props> = ({ block, value, onChange }) => {
  const editorRef = useRef<Editor>(null)
  const initialValue = useRef(value)
  const { isSignedIn } = useAuth()

  const handleOnChange = () => {
    onChange?.(editorRef.current.getContent())
  }

  const richTextComponent = (
    <TinyMCE
      editorRef={editorRef}
      handleOnChange={handleOnChange}
      initialValue={initialValue.current}
    />
  )

  if (!block) {
    return richTextComponent
  }

  return (
    <AutoAudioTranscriber
      mode="TinyMCE"
      formItemName={block.id}
      usageLocation={block.name}
      editorRef={editorRef}
      onChange={onChange}
    >
      {richTextComponent}
      {isSignedIn && (
        <div
          style={{ position: 'absolute', bottom: '2.6rem', right: '4.5rem' }}
        >
          <InputBeautify editorRef={editorRef} onChange={onChange} />
        </div>
      )}
    </AutoAudioTranscriber>
  )
}
